import { configResponsive } from 'ahooks'
export { useResponsive } from 'ahooks'

configResponsive({
  md: 864,
})
